import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    serve : 'https://www.bioflin.com:83/',
    //serve:'http://lineapi.bioflin.com/',
    leftnav:[],
    shop_top:'',
    shop_left:''
  },
  mutations: {
    change_nav(state,v){
      state.leftnav = v
    },
  },
  actions: {
  },
  modules: {
  }
})
